import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
	SwipeableDrawer,
	List,
	ListItem,
	ListItemButton,
	ListItemText,
	ListItemIcon,
	Collapse,
	Divider,
	IconButton,
	Avatar,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import TelegramIcon from "@mui/icons-material/Telegram";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import ThemeToggleButton from "./ThemeToggleButton";

export default function RightSwipeableDrawer() {
	const [openDrawer, setOpenDrawer] = useState(false);
	const [openInstruments, setOpenInstruments] = useState(false);
	const [openProfile, setOpenProfile] = useState(false);

	const toggleDrawer = (open) => () => {
		setOpenDrawer(open);
	};

	const handleToggleInstruments = () => {
		setOpenInstruments((prev) => !prev);
	};

	const handleToggleProfile = () => {
		setOpenProfile((prev) => !prev);
	};

	const navigate = useNavigate(); // Hook for programmatic navigation

	const goToFundamentalsSearch = () => {
		setOpenDrawer(false); // Close the drawer
		navigate("/fundamentals-search");
	};

	const goToStockAnalyzer = () => {
		setOpenDrawer(false); // Close the drawer
		navigate("/stock-analyzer/AAPL/key-indicators");
	};

	return (
		<div>
			<IconButton
				size="large"
				aria-label="show more"
				//   aria-controls='primary-search-account-menu'
				color="inherit"
				onClick={toggleDrawer(true)}
			>
				<MenuIcon />
			</IconButton>
			<SwipeableDrawer
				anchor="right"
				open={openDrawer}
				onClose={toggleDrawer(false)}
				onOpen={toggleDrawer(true)}
				sx={{
					"& .MuiDrawer-paper": {
						bgcolor: "rgba(255, 255, 255, 0.85)", // Semi-transparent background
						backdropFilter: "blur(5px)", // Adds the blur effect
						WebkitBackdropFilter: "blur(5px)", // Safari support
						borderTopLeftRadius: "12px",
						borderBottomLeftRadius: "12px",
					},

					// color: 'primary.main'
				}}
			>
				<List sx={{ width: 260 }}>
					<ListItem
						disablePadding
						sx={{
							marginTop: "2rem",
							marginBottom: "1.5rem",
							justifyContent: "center",
						}}
					>
						<IconButton sx={{ p: 0 }}>
							<Avatar sx={{ width: 75, height: 75 }} />
						</IconButton>
						{/* <ListItemText primary="Dark Mode"/> */}
					</ListItem>
					{/* Instruments */}
					<ListItem disablePadding>
						<ListItemButton
							onClick={handleToggleInstruments}
							sx={{ pt: 1.5, pb: 1.5 }}
						>
							<ListItemIcon>
								<ShowChartIcon />
							</ListItemIcon>
							<ListItemText
								primary="Instruments"
								primaryTypographyProps={{
									fontWeight: "bold",
									fontSize: "18px",
								}}
							/>
							{openInstruments ? <ExpandLess /> : <ExpandMore />}
						</ListItemButton>
					</ListItem>
					<Collapse in={openInstruments} timeout="auto" unmountOnExit>
						<List component="div" disablePadding sx={{ pl: 4 }}>
							<ListItem disablePadding>
								<ListItemButton onClick={goToStockAnalyzer}>
									<ListItemText primary="Stock Analyzer" />
								</ListItemButton>
							</ListItem>
							<ListItem disablePadding>
								<ListItemButton
									onClick={goToFundamentalsSearch}
								>
									<ListItemText primary="Fundamentals Search" />
								</ListItemButton>
							</ListItem>
							<ListItem disablePadding>
								<ListItemButton>
									<ListItemText primary="Fundamentals Screener" />
								</ListItemButton>
							</ListItem>
							<ListItem disablePadding>
								<ListItemButton>
									<ListItemText primary="Watch List" />
								</ListItemButton>
							</ListItem>
						</List>
					</Collapse>

					{/* <Divider /> */}
					{/* Community Chat */}
					<ListItem disablePadding>
						<ListItemButton sx={{ pt: 1.5, pb: 1.5 }}>
							<ListItemIcon>
								<TelegramIcon />
							</ListItemIcon>
							<ListItemText
								primary="Chat"
								primaryTypographyProps={{
									fontWeight: "bold",
									fontSize: "18px",
								}}
							/>
						</ListItemButton>
					</ListItem>

					{/* <Divider /> */}
					{/* Shop */}
					<ListItem disablePadding>
						<ListItemButton sx={{ pt: 1.5, pb: 1.5 }}>
							<ListItemIcon>
								<ShoppingBagIcon />
							</ListItemIcon>
							<ListItemText
								primary="Shop"
								primaryTypographyProps={{ fontSize: "18px" }}
							/>
						</ListItemButton>
					</ListItem>

					{/* <Divider /> */}

					{/* Profile */}
					<ListItem disablePadding>
						<ListItemButton
							onClick={handleToggleProfile}
							sx={{ pt: 1.5, pb: 1.5 }}
						>
							<ListItemIcon>
								<AccountCircle />
							</ListItemIcon>
							<ListItemText
								primary="Account"
								primaryTypographyProps={{
									fontWeight: "bold",
									fontSize: "18px",
								}}
							/>
							{openProfile ? <ExpandLess /> : <ExpandMore />}
						</ListItemButton>
					</ListItem>
					<Collapse in={openProfile} timeout="auto" unmountOnExit>
						<List component="div" disablePadding sx={{ pl: 4 }}>
							<ListItem disablePadding>
								<ListItemButton>
									<ListItemText primary="Profile" />
								</ListItemButton>
							</ListItem>
							<ListItem disablePadding>
								<ListItemButton>
									<ListItemText primary="Membership" />
								</ListItemButton>
							</ListItem>
							<ListItem disablePadding>
								<ListItemButton>
									<ListItemText primary="Glossary" />
								</ListItemButton>
							</ListItem>
							<Divider />
							<ListItem disablePadding>
								<ListItemButton>
									<ListItemIcon>
										<SettingsIcon />
									</ListItemIcon>
									<ListItemText primary="Settings" />
								</ListItemButton>
							</ListItem>
							<ListItem disablePadding>
								<ListItemButton>
									<ListItemIcon>
										<LogoutIcon />
									</ListItemIcon>
									<ListItemText primary="Log Out" />
								</ListItemButton>
							</ListItem>
							{/* <Divider />
							<ListItem
								disablePadding
								sx={{
									// marginLeft: "25%",
									// marginRight: "auto",
									marginTop: "1rem",
									marginBottom: "0.5rem",
									// marginRight: "60%",
									// marginLeft: "40%",
									justifyContent: "center",
								}}
							>
								<ThemeToggleButton></ThemeToggleButton>
								// <ListItemText primary="Dark Mode"/>
							</ListItem> */}
						</List>
					</Collapse>
					{/* <Divider /> */}
					<ListItem
						disablePadding
						sx={{
							marginTop: "1.5rem",
							marginBottom: "1rem",
							justifyContent: "center",
						}}
					>
						<ThemeToggleButton></ThemeToggleButton>
						{/* <ListItemText primary="Dark Mode"/> */}
					</ListItem>
				</List>
			</SwipeableDrawer>
		</div>
	);
}
